import React, { useState, useContext } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, Nav, NavItem, NavLink } from 'reactstrap';
import { Link, useHistory } from 'react-router-dom';
import AulaUserContext, { clearAulaSession } from './aulaUserContext';
import logoSalidas from '../Resources/logo-salidas.png';
import './AulaNavbar.css';

const AulaNavbar = () => {
    const { aulaAuth, setAulaAuth } = useContext(AulaUserContext);
    const [collapsed, setCollapsed] = useState(true);
    const history = useHistory();

    const handleLogout = () => {
        clearAulaSession();
        setAulaAuth({ token: null, nombre: null, rol: null });
        history.push('/aula/login');
    };

    return (
        <header>
            <Navbar className="navbar-expand-sm navbar-toggleable-sm aula-navbar mb-4" dark>
                <Container>
                    <NavbarBrand tag={Link} to={aulaAuth.token ? '/aula' : '/aula/login'} className="d-flex align-items-center">
                        <img src={logoSalidas} alt="Salidas Inclusivas" className="aula-navbar-logo mr-2" />
                        Aula Virtual
                    </NavbarBrand>
                    <NavbarToggler onClick={() => setCollapsed((c) => !c)} className="mr-2" />
                    <Collapse isOpen={!collapsed} navbar>
                        <Nav className="ml-auto" navbar>
                            <NavItem><NavLink tag="a" href="/">Volver al sitio</NavLink></NavItem>
                            {aulaAuth.token && <NavItem><NavLink tag={Link} to="/aula">Catálogo</NavLink></NavItem>}
                            {aulaAuth.token && aulaAuth.rol === 'Admin' &&
                                <NavItem><NavLink tag={Link} to="/aula/admin">Panel admin</NavLink></NavItem>}
                            {aulaAuth.token && <NavItem><NavLink tag={Link} to="/aula/perfil">Mi perfil</NavLink></NavItem>}
                            {aulaAuth.token
                                ? <NavItem><NavLink href="#" onClick={handleLogout}>Salir ({aulaAuth.nombre})</NavLink></NavItem>
                                : (
                                    <>
                                        <NavItem><NavLink tag={Link} to="/aula/login">Ingresar</NavLink></NavItem>
                                        <NavItem><NavLink tag={Link} to="/aula/registro">Registrarse</NavLink></NavItem>
                                    </>
                                )}
                        </Nav>
                    </Collapse>
                </Container>
            </Navbar>
        </header>
    );
};

export default AulaNavbar;
